//---- components ---------
//---- mixins -------------
//---- services -----------
//---- other --------------
import store from '../store/index.js';
//---- 3rd-parties --------
import VueApp from '@/main.js'
import vueI18n from "@/app/services/i18n.service.js"

// notification class is meant for showing the deferent type of notifications.
// Notification can contains info, warning and error
class NotificationService {
  // add an plain-text info toast
  // @arg message plain-text message
  // @arg id (optional) user supplied id, do not use integers
  // @arg toast (optional) whether to do it as a toast
  // @return the id for this toast
  info(message, id, toast) {
    if (typeof toast == 'undefined')
      toast = true;
    store.commit("addNotification", { id, type: "info", message, toast })
    return id || store.state.lastNotificationId
  }

  // add an html info toast
  // @arg message html message
  // @arg id (optional) user supplied id, do not use integers
  // @arg toast (optional) whether to do it as a toast
  // @return the id for this toast
  htmlInfo(htmlMessage, id, toast) {
    if (typeof toast == 'undefined')
      toast = true;
    store.commit("addNotification", { id, type: "info", htmlMessage, toast })
    return id || store.state.lastNotificationId
  }

  // add an plain-text warn toast
  // @arg message plain-text message
  // @arg id (optional) user supplied id, do not use integers
  // @arg toast (optional) whether to do it as a toast
  // @return the id for this toast
  warn(message, id, toast) {
    if ((typeof toast) == 'undefined')
      toast = true;
    store.commit("addNotification", { id, type: "warning", message, toast })
    return id || store.state.lastNotificationId
  }

  // add an html warn toast
  // @arg message html message
  // @arg id (optional) user supplied id, do not use integers
  // @arg toast (optional) whether to do it as a toast
  // @return the id for this toast
  htmlWarn(htmlMessage, id, toast) {
    if ((typeof toast) == 'undefined')
      toast = true;
    store.commit("addNotification", { id, type: "warning", htmlMessage, toast })
    return id || store.state.lastNotificationId
  }

  // add an plain-text error toast
  // @arg message plain-text message
  // @arg id (optional) user supplied id, do not use integers
  // @arg toast (optional) whether to do it as a toast
  // @return the id for this toast
  error(message, id, toast) {
    if ((typeof toast) == 'undefined')
      toast = true;
    store.commit("addNotification", { id, type: "error", message: message.replaceAll("\n", "<br/>"), toast })
    return id || store.state.lastNotificationId
  }

  // add an html error toast
  // @arg message html message
  // @arg id (optional) user supplied id, do not use integers
  // @arg toast (optional) whether to do it as a toast
  // @return the id for this toast
  htmlError(htmlMessage, id, toast) {
    if ((typeof toast) == 'undefined')
      toast = true;
    store.commit("addNotification", { id, type: "error", htmlMessage, toast })
    return id || store.state.lastNotificationId
  }

  // programmatically remove a toast
  // @arg id of the toast to remove
  removeNotification(id) {
    if (store.state.notifications && store.state.notifications.find((x) => x.id == id))
      store.commit("removeNotification", id)
  }

  // programmatically remove a all toast
  clearAllNotification() {
    store.commit("clearAllNotification")
  }

  // html confirmation message
  showHTMLConfirmationMessage(message) {
    const vm = VueApp
    const h = vm.$createElement
    // Using HTML string
    const messageVNode = h('div', { domProps: { innerHTML: message } })
    // We must pass the generated VNodes as arrays
    return vm.$bvModal.msgBoxConfirm([messageVNode], {
      size: 'md',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: vm.$t('label.choose.yes'),
      cancelTitle: vm.$t('label.choose.no'),
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
    })
  }
  
  // simple string confirmation message
  showConfirmation(message, options) {
    const vm = VueApp

    var okVariant = options?.okVariant || 'success';

    return vm.$bvModal.msgBoxConfirm(message, {
      size: 'md',
      buttonSize: 'sm',
      okVariant,
      okTitle: vm.$t('label.choose.yes'),
      cancelTitle: vm.$t('label.choose.no'),
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
    })
  }

  timeOutNotification(message) {
    const vm = VueApp

    return vm.$bvModal.msgBoxOk(message, {
      title: 'Session expired',
      titleClass: 'h1',
      size: 'md',
      buttonSize: 'md',
      headerClass: 'p-2 border-bottom-0 mx-auto',
      okTitle: vm.$t('login.enter-button'),
      hideHeaderClose: true,
      bodyClass: 'p-0 mx-auto h5',
      footerClass: 'p-5 border-top-0 mx-auto',
      centered: true
    })
  }

  // confirmation message
  showConfirmationMessage(message, okTitle, cancelTitle) {
    const vm = VueApp

    return vm.$bvModal.msgBoxConfirm(message, {
      size: 'md',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: okTitle,
      cancelTitle: cancelTitle,
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
    })
  }

  showMessageOk(message) {
    const vm = VueApp

    return vm.$bvModal.msgBoxOk(message, {
      size: 'md',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: vm.$t('button.ok'),
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
    })
  }

  notificationFilter(notifications) {
    for (var notification of notifications) {
      if (notification.expired == true) 
        continue;
      // console.log(notification);

      // if we have a key instead of a message, use the key
      if (!notification.message && notification.key) 
        notification.message = vueI18n.t(notification.key);

      var html = notification.format == 'html';
      switch(notification.level) {
        case 'error':
          if (html)
            this.htmlError(notification.message);
          else
            this.error(notification.message);
          break;
        case 'warn':
          if (html)
            this.htmlWarn(notification.message);
          else
            this.warn(notification.message);
          break;
        case 'studio':
          if (html)
            this.htmlInfo(notification.message, null, false);
          else
            this.info(notification.message, null, false);
          break;
        case 'info':
        default:
          if (html)
            this.htmlInfo(notification.message);
          else
            this.info(notification.message);
          break;
      }
    }
  }
}
export default new NotificationService();